module.exports = __webpack_public_path__ + "static/specialised-e99f28d5a8c64c5f955d74b1f0f69fd0.svg";